import React, { useContext, useEffect } from "react";
import * as Sentry from "@sentry/react";
import { useTranslation } from "react-i18next";
import { RootStoreContext } from "src/stores/RootStore";
import { observer } from "mobx-react";
import { UI } from "@wwimmo/ui";
import { getParams, Route, selectRoute } from "src/config/routes";
import { AssemblyDetailEditForm } from "./editform/AssemblyDetailEditForm";
import { useHistory } from "react-router-dom";

const AssemblyDetailsBase = () => {
    const { t } = useTranslation();
    const { navStore, assemblyStore, authStore } = useContext(RootStoreContext);
    const history = useHistory();

    const role = authStore.user?.role;
    let params = getParams(Route.assemblyDetails, role);
    const assemblyId = params["assemblyid"];

    useEffect(() => {
        assemblyStore.loadCurrentAssembly(assemblyId);
        assemblyStore.setCurrentAssemblyRealestates([]);

        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        assemblyStore.setAgendaItemsExists(false);
        navStore.setTitle(assemblyStore.currentAssemblyTitle || "");
        navStore.setActionButtonMiddle(null);
        navStore.setActionButtonRight(null);
        navStore.setBackbutton(
            selectRoute(Route.assemblies, authStore.user?.role),
            t("screens.assemblies.sidebar_title").toString()
        );
    }, [navStore, assemblyStore.currentAssemblyTitle, t, authStore.user?.role, assemblyStore]);

    useEffect(() => {
        if (assemblyStore.currentAssembly?.livemode) {
            history.push(
                selectRoute(Route.assemblyLiveMode, authStore.user?.role, {
                    assemblyid: assemblyStore.currentAssembly?.id || ""
                })
            );
        }
    }, [assemblyStore.currentAssembly?.livemode, history, authStore.user?.role, assemblyStore.currentAssembly?.id]);

    return (
        <UI.Container>
            <UI.Row>
                <UI.Col xl={12}>
                    {assemblyStore.hasCurrentAssemblyLoaded ? <AssemblyDetailEditForm /> : undefined}
                </UI.Col>
            </UI.Row>
        </UI.Container>
    );
};

export const AssemblyDetails = Sentry.withProfiler(observer(AssemblyDetailsBase));
